import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared.module';
import { GridUsersListModule } from 'src/app/views/grid-user-list/grid-users-list.module';
import { ProjectsModule } from '../../projects/projects.module';
import { DeactivatedUsersComponent } from './deactivated-users.component';
import { DeactivatedUsersService } from './deactivated-users.service';

@NgModule({
  providers: [DeactivatedUsersService],
  declarations: [DeactivatedUsersComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    NgbModule,
    NgbPaginationModule,
    ProjectsModule,
    GridUsersListModule,
  ],
})
export class DeactivatedUsersModule {}
